import { formatPrice, type RaisonCorrespondance } from '@artosera/shared';
import { useTranslation } from 'react-i18next';
import { useArtiste } from '../../api/artistes.js';
import styles from './Profils.module.css';

function Raison({ galerieSlug, raison }: { galerieSlug: string; raison: RaisonCorrespondance }) {
  const { t, i18n } = useTranslation('regie');
  const artisteId = 'artisteId' in raison.params ? raison.params.artisteId : null;
  const artiste = useArtiste(galerieSlug, artisteId);
  const langue = i18n.language === 'en' ? 'en' : 'fr';
  let params: Record<string, unknown> = raison.params;
  switch (raison.code) {
    case 'artiste_recherche':
      params = { artiste: artiste.data?.nom ?? t('profils.artisteInconnu') };
      break;
    case 'artiste_achete':
      params = {
        artiste: artiste.data?.nom ?? t('profils.artisteInconnu'),
        nombre: raison.params.nombre,
        format: raison.params.formatDominant
          ? t(`profils.formats.${raison.params.formatDominant}`)
          : '—',
      };
      break;
    case 'format':
      params = { format: t(`profils.formats.${raison.params.format}`) };
      break;
    case 'type':
      params = { type: t(`profils.types.${raison.params.type}`) };
      break;
    case 'budget':
      params = {
        min:
          raison.params.budgetMinCentimes === null
            ? '—'
            : formatPrice(raison.params.budgetMinCentimes, 'EUR', langue),
        max:
          raison.params.budgetMaxCentimes === null
            ? '—'
            : formatPrice(raison.params.budgetMaxCentimes, 'EUR', langue),
      };
      break;
  }
  return <li>{t(`profils.raisons.${raison.code}`, params)}</li>;
}

export function RaisonsCorrespondance({
  galerieSlug,
  raisons,
}: {
  galerieSlug: string;
  raisons: readonly RaisonCorrespondance[];
}) {
  return (
    <ul className={styles.raisons}>
      {raisons.map((raison, index) => (
        <Raison key={index} galerieSlug={galerieSlug} raison={raison} />
      ))}
    </ul>
  );
}
